import { UserApi } from 'api/api'
import { useMutation } from 'react-query'
import { UserProfile } from 'types/types'
import { QUERY_KEYS } from '../src/lib/cache-keys/queryKeys'

export const useUpdateProfile = (profileData: Partial<UserProfile>) => {
  const { data, isLoading, error, mutate } = useMutation(QUERY_KEYS.UPDATE_PROFILE, () =>
    UserApi.updateUserProfile(profileData),
  )
  return { data, isLoading, error, mutate }
}
